/**
 * Posts service
 */

import Resource from './resource'

export default new Resource('posts')



// WEBPACK FOOTER //
// ./src/libraries/services/posts.js